export function storageMock(): Storage {
  let storage: Record<string, string> = {}
  return {
    setItem: function (key: string, value: string) {
      storage[key as keyof Storage] = value || ''
    },
    getItem: function (key: string) {
      return key in storage ? storage[key] : null
    },
    removeItem: function (key: string) {
      delete storage[key]
    },
    get length() {
      return Object.keys(storage).length
    },
    key: function (index: number) {
      const keys = Object.keys(storage)
      return keys[index] || null
    },
    clear: function() {
      storage = {}
    }
  }
}

